import React, { useEffect, useState } from "react"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { AiOutlineMail } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiOutlineEye } from 'react-icons/ai';
import { AiOutlineEyeInvisible } from 'react-icons/ai';
import { useAlertContext } from "../contexts/AlertContext";
import { useLoaderContext } from "../contexts/LoaderContext";
import { useUserContext } from "../contexts/UserContext";
import { CiUser } from "react-icons/ci";


const LoginPage = () => {
    const navigate = useNavigate()
    const { setAlertMessage, setShowAlert } = useAlertContext();
    const { setIsLoading } = useLoaderContext();
    const [showPassword, setShowPassword] = useState(false);
    const { setLoginUser } = useUserContext();



    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const [user, setUser] = useState({
        username: "",
        password: ""
    })

    const handleChange = e => {
        const { name, value } = e.target
        setUser({
            ...user,
            [name]: value
        })
    }



    const login = () => {
        if (user.username === "" || user.password === "") {
            setAlertMessage("Please fill all fields");
            setShowAlert(true);
            return;
        }
        setIsLoading(true)
    
        const allowedUsername = process.env.REACT_APP_ALLOWED_USER;
        const allowedPassword = process.env.REACT_APP_ALLOWED_PASS;
    
        // Check if the user credentials match
        if (user.username === allowedUsername && user.password === allowedPassword) {
    
            setAlertMessage("Login successful!");
            setShowAlert(true);

            const authenticatedUser={
                username:allowedUsername,
                password:allowedPassword,
            }
    
            // Set the user as logged in
            setLoginUser(authenticatedUser);
            setIsLoading(false)
            localStorage.setItem('user', JSON.stringify(authenticatedUser));
            navigate("/");

    
        } else {
            setAlertMessage("Invalid username or password");
            setShowAlert(true);
            setIsLoading(false)
        }
    };
    


    return (
        <>

            <div className="">



                <div className="auth_container">
                    <div className="auth_form_box">
                        <div className="auth_profile">
                            <CgProfile />
                        </div>
                        <h3>Login</h3>

                        <div className="auth_item">
                            <div className="auth_item_icon">
                                <CiUser />
                            </div>

                            <input
                                type="text"
                                name="username"
                                required
                                placeholder="Username"
                                value={user.username}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="auth_item">
                            <div className="auth_item_icon">
                                <RiLockPasswordFill />
                            </div>
                            <input
                                type={showPassword ? "text" : "password"}
                                required
                                placeholder="Password"
                                name="password"
                                value={user.password}
                                onChange={handleChange}
                            />
                            <div className="auth_item_icon">
                                {showPassword ? (
                                    <button onClick={toggleShowPassword}><AiOutlineEyeInvisible /></button>
                                ) : (
                                    <button onClick={toggleShowPassword}><AiOutlineEye /></button>

                                )}

                            </div>
                        </div>

                        <div className="auth_button">
                            <button onClick={login}> LOGIN </button>
                        </div>



                    </div>
                </div>

            </div>
        </>
    )
}

export default LoginPage